import { Link } from "react-router-dom";

import logoLight from "assets/logo-docttorpay-horizontal.svg";
import logoDark from "assets/logo-docttorpay-white-horizontal.svg";
import { useAuth } from "providers/Auth";

import LoginForm from "./components/LoginForm";
import * as C from "./styles";

const Login = () => {
  const { isLoading } = useAuth();

  return (
    <C.LoginPage>
      <C.TopAccent />

      <C.LogoArea>
        <img src={logoDark} alt="DocttorPay" />
      </C.LogoArea>

      <C.LoginCard>
        <C.CardTitle>Bem-vindo de volta</C.CardTitle>
        <C.CardSubtitle>
          Acesse com e-mail, CPF ou CNPJ
        </C.CardSubtitle>

        <LoginForm />

        <C.RegisterRow>
          Ainda não tem conta?{" "}
          <Link
            to="/cadastro"
            style={{
              pointerEvents: isLoading ? "none" : undefined,
              opacity: isLoading ? 0.5 : undefined,
            }}
            aria-disabled={isLoading}
          >
            Cadastre-se grátis
          </Link>
        </C.RegisterRow>
      </C.LoginCard>

      <C.TrustRow>
        <i className="uil uil-lock-alt" aria-hidden="true" />
        Conexão segura com criptografia SSL
      </C.TrustRow>
    </C.LoginPage>
  );
};

export default Login;
